var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.59692H15C13.6739 2.59692 12.4021 3.12371 11.4645 4.06139C10.5268 4.99907 10 6.27084 10 7.59692V10.5969H7V14.5969H10V22.5969H14V14.5969H17L18 10.5969H14V7.59692C14 7.33171 14.1054 7.07735 14.2929 6.88982C14.4804 6.70228 14.7348 6.59692 15 6.59692H18V2.59692Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0c25e5df7a9b4a12d5c8483eff4cf851.svg";
export { ForwardRef as ReactComponent };